/**
 * 重新加载管理后台入口，并通过查询参数绕过 CDN 或浏览器中的旧 HTML 缓存。
 *
 * Vite 的路由页面使用内容哈希分包。发布新版本后，仍运行旧主包的浏览器可能继续请求
 * 已被替换的旧分包，因此不能只刷新同一个 URL，必须重新获取最新入口文档。
 */
export function reloadApplication(routeFullPath?: string) {
  const url = new URL(window.location.href)
  url.searchParams.set('_appReload', Date.now().toString())

  if (routeFullPath) {
    url.hash = `#${routeFullPath}`
  }

  window.location.replace(url.toString())
}
